import { render, staticRenderFns } from "./per-pay-drop.vue?vue&type=template&id=dca3167c&scoped=true&"
import script from "./per-pay-drop.vue?vue&type=script&lang=js&"
export * from "./per-pay-drop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca3167c",
  null
  
)

export default component.exports